<div class="video-player-content video-player-fs-root" #playerHost>
  <div class="video-player-header-row">
    <span class="video-player-title" [attr.title]="data.title">{{ data.title }}</span>
    <button
      type="button"
      class="video-player-fs-btn"
      (click)="toggleBrowserFullscreen()"
      [attr.aria-label]="isPageFullscreen ? 'Exit full screen' : 'Enter full screen'">
      <i class="fa" [class.fa-expand]="!isPageFullscreen" [class.fa-compress]="isPageFullscreen" aria-hidden="true"></i>
      <span class="video-player-fs-btn__text">{{ isPageFullscreen ? 'Exit full screen' : 'Full screen' }}</span>
    </button>
  </div>

  <!-- No mat-dialog-content: Material applies max-height on .mat-mdc-dialog-content and clips Vimeo's bottom controls -->
  <div class="video-player-stage">
    <div class="video-player" [innerHTML]="sanitizedHTML"></div>
  </div>
</div>
